module.exports = __webpack_public_path__ + "img/antix.2d5d4372.png";